import { render, staticRenderFns } from "./VxCard.vue?vue&type=template&id=f5126d14"
import script from "./VxCard.vue?vue&type=script&lang=js"
export * from "./VxCard.vue?vue&type=script&lang=js"
import style0 from "./VxCard.vue?vue&type=style&index=0&id=f5126d14&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5126d14')) {
      api.createRecord('f5126d14', component.options)
    } else {
      api.reload('f5126d14', component.options)
    }
    module.hot.accept("./VxCard.vue?vue&type=template&id=f5126d14", function () {
      api.rerender('f5126d14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vx-card/VxCard.vue"
export default component.exports